import { FC } from 'react';

import { ButtonAction } from 'components/button/ButtonAction';
import { Modal, Row, Typography, closeModal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { LevelItem } from '../styles/dashboard';

import { ReactComponent as TickIcon } from 'assets/icons/icon-tick-orange.svg';

export const LevelLessonModal: FC<{
  onSubmit: () => void;
  setLevelLesson: (value: number) => void;
  levelLesson: number;
  onCancel: () => void;
}> = ({ onSubmit, setLevelLesson, levelLesson, onCancel }) => {
  return (
    <Modal
      modalKey={MODAL_KEY.LEVEL_LESSON}
      hideCloseIcon
      onSubmit={() => {}}
      size="lg"
      header={
        <Typography variant="h4" style={{ fontSize: 22, fontWeight: '500' }}>
          Choose a lesson level to add exercises
        </Typography>
      }
      footer={
        <ButtonAction
          disabledCancel={false}
          disabledSubmit={!levelLesson}
          titleCancel="Cancel"
          titleSubmit="Add"
          style={{ justifyContent: 'end', padding: '0px 40px 24px 0px' }}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      }
    >
      {[1, 2, 3].map((el, index) => (
        <LevelItem>
          <Row
            key={index}
            className={levelLesson === el ? 'selected' : ''}
            onClick={() => (levelLesson === el ? null : setLevelLesson(el))}
            style={{
              height: '56px',
              padding: '0px 16px',
              justifyContent: 'space-between',
              cursor: 'pointer',
              alignItems: 'center',
            }}
          >
            <Typography variant="h5">Level {el}</Typography>

            <div style={{ width: 32 }}>{levelLesson === el && <TickIcon />}</div>
          </Row>
        </LevelItem>
      ))}
    </Modal>
  );
};
